import React from 'react';
import ListItem from '@smart-tv/components/list';
import { FocusHandler } from '@noriginmedia/norigin-spatial-navigation';

const ITERATIONS = 10_000_000;

function benchmarkPi(): number {
  let pi = 0;
  for (let i = 0; i < ITERATIONS; i++) {
    pi += (i % 2 === 0 ? 1 : -1) / (2 * i + 1);
  }
  return pi;
}

// Lower ms = better. Thresholds based on typical Tizen TV performance.
function cpuRating(ms: number): string {
  if (ms < 50) return 'Excellent';
  if (ms < 100) return 'Good';
  if (ms < 200) return 'Fair';
  return 'Poor';
}

interface Props {
  listItemClassName?: string;
  onFocus?: FocusHandler;
}

const CpuBenchmark: React.FC<Props> = ({ listItemClassName, onFocus }) => {
  const [result, setResult] = React.useState<string>('Press to run');
  const [running, setRunning] = React.useState(false);

  const runBenchmark = React.useCallback(() => {
    if (running) return;
    setRunning(true);
    setResult('Running…');
    setTimeout(() => {
      const start = performance.now();
      benchmarkPi();
      const ms = Math.round(performance.now() - start);
      setResult(`${ms}ms — ${cpuRating(ms)}`);
      setRunning(false);
    }, 0);
  }, [running]);

  return (
    <ListItem
      listItemProps={{ className: listItemClassName }}
      onEnterPress={runBenchmark}
      onFocus={onFocus}
      data={['CPU Benchmark', result]}
    />
  );
};

export default CpuBenchmark;
